import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import API from '../endpoints';
import { Match, MatchPeriodFilter, MatchSort, MatchStatusFilter, PaginatedResponse } from '@repo/types';
import { getAccessToken } from '@data/utils/getAccessToken';

const accessToken = getAccessToken();

// 60 seconds frontend cache for fetching matches
const CACHE_TIME = 60 * 1000;

type MatchesQueryParams = {
  league?: string;
  page?: number;
  limit?: number;
  period?: MatchPeriodFilter;
  startDate?: string;
  endDate?: string;
  sort?: MatchSort;
  status?: MatchStatusFilter;
  teamId?: string | null;
  competition?: string | null;
  periodLimit?: number;
};

type QueryOptions = {
  enabled: boolean;
};

export const useMatchesQuery = (params: MatchesQueryParams, options?: QueryOptions) => {
  return useQuery({
    queryKey: ['matches', params],
    queryFn: fetchMatches,
    staleTime: !accessToken ? CACHE_TIME : undefined,
    ...(options ?? {}),
  });
};

const fetchMatches: QueryFunction<PaginatedResponse<Match>, [string, MatchesQueryParams]> = async ({ queryKey }) => {
  const [, params] = queryKey;
  const accessToken = getAccessToken();

  let headers = {};
  if (accessToken) {
    headers = {
      Authorization: `Bearer ${accessToken}`,
    };
  }

  const { data } = await axios.get<PaginatedResponse<Match>>(API.endpoints.matches, {
    params,
    headers,
  });

  return data;
};
